module.exports = __webpack_public_path__ + "static/media/theater_tn.b4db1f18.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Sizilien/theater_tn.jpg
// module id = 778
// module chunks = 0